import React, { useState } from 'react';
import { CONSENT_CATEGORIES } from '../utils/consentManager';

const CookieConsentBanner = ({ onAcceptAll, onEssentialOnly, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [showDetails, setShowDetails] = useState(false);

  const bannerStyles = {
    container: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#2B373B',
      color: 'white',
      padding: '1rem',
      zIndex: 1000,
      borderTop: '2px solid #4e503b',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
      maxHeight: showDetails ? '80vh' : 'auto',
      overflowY: showDetails ? 'auto' : 'visible',
    },
    content: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '1rem',
    },
    text: {
      flex: 1,
      minWidth: '300px',
      fontSize: '0.9rem',
      lineHeight: '1.4',
    },
    buttonContainer: {
      display: 'flex',
      gap: '0.5rem',
      flexWrap: 'wrap',
    },
    button: {
      padding: '0.5rem 1rem',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: '600',
      transition: 'all 0.2s',
    },
    essentialButton: {
      backgroundColor: 'transparent',
      color: 'white',
      border: '1px solid #4e503b',
    },
    acceptButton: {
      backgroundColor: '#4e503b',
      color: 'white',
    },
    dismissButton: {
      backgroundColor: 'transparent',
      color: '#cccccc',
      fontSize: '0.8rem',
      padding: '0.25rem 0.5rem',
    },
    link: {
      color: '#4e503b',
      textDecoration: 'underline',
    },
    detailsSection: {
      marginTop: '1rem',
      padding: '1rem',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '4px',
    },
    detailsButton: {
      backgroundColor: 'transparent',
      color: '#4e503b',
      border: 'none',
      textDecoration: 'underline',
      cursor: 'pointer',
      fontSize: '0.9rem',
      padding: '0.5rem 0',
    },
    consentCategory: {
      marginBottom: '1rem',
      padding: '0.5rem',
      borderLeft: '3px solid #4e503b',
    },
    categoryTitle: {
      fontWeight: 'bold',
      marginBottom: '0.25rem',
    },
    categoryDescription: {
      fontSize: '0.85rem',
      color: '#cccccc',
    },
  };

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) onDismiss();
  };

  const consentCategories = [
    {
      key: CONSENT_CATEGORIES.SECURITY_STORAGE,
      title: 'Security Cookies (Required)',
      description: 'Essential for website security and preventing fraud. Always active.',
      required: true
    },
    {
      key: CONSENT_CATEGORIES.ANALYTICS_STORAGE,
      title: 'Analytics Cookies',
      description: 'Help us understand how visitors use our website to improve your experience.',
      required: false
    },
    {
      key: CONSENT_CATEGORIES.AD_STORAGE,
      title: 'Advertising Cookies',
      description: 'Used to display personalized advertisements and measure ad performance.',
      required: false
    },
    {
      key: CONSENT_CATEGORIES.FUNCTIONALITY_STORAGE,
      title: 'Functionality Cookies',
      description: 'Enable enhanced website features and personalization.',
      required: false
    }
  ];

  if (!isVisible) return null;

  return (
    <div style={bannerStyles.container}>
              <div style={bannerStyles.content}>
          <div style={bannerStyles.text}>
            We use cookies to improve your experience. By continuing to use this site, 
            you agree to our use of cookies.{' '}
            <button 
              onClick={() => setShowDetails(!showDetails)}
              style={bannerStyles.detailsButton}
            >
              {showDetails ? 'Hide details' : 'Show details'}
            </button>
            {' '}or{' '}
            <a href="/privacy" style={bannerStyles.link}>
              learn more
            </a>
          </div>
          
          {showDetails && (
            <div style={bannerStyles.detailsSection}>
              {consentCategories.map(category => (
                <div key={category.key} style={bannerStyles.consentCategory}>
                  <div style={bannerStyles.categoryTitle}>
                    {category.title}
                    {category.required && ' (Always Active)'}
                  </div>
                  <div style={bannerStyles.categoryDescription}>
                    {category.description}
                  </div>
                </div>
              ))}
            </div>
          )}
          
          <div style={bannerStyles.buttonContainer}>
            <button
              onClick={onEssentialOnly}
              style={{ ...bannerStyles.button, ...bannerStyles.essentialButton }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = 'rgba(78, 80, 59, 0.1)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
            >
              Essential Only
            </button>
            <button
              onClick={onAcceptAll}
              style={{ ...bannerStyles.button, ...bannerStyles.acceptButton }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#5a5f45'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#4e503b'}
            >
              Accept All
            </button>
            <button
              onClick={handleDismiss}
              style={{ ...bannerStyles.button, ...bannerStyles.dismissButton }}
            >
              ×
            </button>
          </div>
        </div>
    </div>
  );
};

export default CookieConsentBanner; 